module.exports = __webpack_public_path__ + "0c483c31b9ad01fc129241a2c508ccda.svg";